import { render, staticRenderFns } from "./ModerationHeader.vue?vue&type=template&id=5e8c3ffe&scoped=true&"
import script from "./ModerationHeader.vue?vue&type=script&lang=js&"
export * from "./ModerationHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModerationHeader.vue?vue&type=style&index=0&id=5e8c3ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8c3ffe",
  null
  
)

export default component.exports